import styled, { keyframes } from 'styled-components'
import { BLACK, VIOLET_400, WHITE } from '@styles/colors'
import { INTER } from '@styles/fonts'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

interface ContainerProps {
  $animationDuration?: number;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 12px;
  background-color: ${VIOLET_400};
  z-index: 0;
  padding: 12px;
  cursor: pointer;
  animation: ${fadeIn} ${props => props.$animationDuration || 0.5}s ease-in-out;
`

export const BackgroundImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: ${BLACK};
  opacity: 0.4;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  z-index: 3;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const TextContainer = styled.div`
  color: ${WHITE};
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const TitleText = styled.span`
  font-family: ${INTER.bold};
`

export const SubtitleText = styled.span`
  font-family: ${INTER.regular};
`

export const CloseButton = styled.div`
  cursor: pointer;
`

export const ProgressContainer = styled.div`
  z-index: 3;
  margin-top: 12px;
  margin-bottom: 8px;
`

export const StepText = styled.div`
  z-index: 3;
`

export const StepTextContent = styled.span`
  font-family: ${INTER.medium};
  color: ${WHITE};
`

export const ModalContainer = styled.div`
  position: absolute;
  z-index: 999;
`
